import React from 'react';
import { motion } from 'framer-motion';
export function IdentificationSection() {
  return <section className="w-full bg-navy-dark py-10 md:py-14" data-id="element-97">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98">
        {/* Emotional 2:37 AM image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex justify-center mb-12" data-id="element-99">
          <div className="relative w-full max-w-lg overflow-hidden rounded-xl" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/vnqZ2DZqaNbPKbSij5pgA5/hf_20260218_162154_fa115925-ac61-4ad3-9326-e0983f147151.png" alt="Mujer despierta a las 2:37 AM" className="w-full h-auto object-cover rounded-xl" data-id="element-101" />
            {/* Subtle vignette overlay */}
            <div className="absolute inset-0 rounded-xl" style={{
            boxShadow: 'inset 0 0 60px rgba(10, 14, 26, 0.5)'
          }} data-id="element-102" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-103">
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-4" data-id="element-104">
            No es que no sepas dormir.
          </h2>

          <p className="font-playfair text-xl md:text-2xl italic text-amber mb-12" data-id="element-105">
            Es que nadie te enseñó a apagar la alarma interna.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg text-cream-muted leading-relaxed" data-id="element-106">
          <p data-id="element-107">
            Te acuestas agotada. Cierras los ojos. Y todo parece estar bien.
          </p>

          <p data-id="element-108">Hasta que a las 2 o 3 de la madrugada…</p>

          <p className="text-cream text-xl" data-id="element-109">Tu mente se enciende.</p>

          <p data-id="element-110">
            Pendientes. Errores. Miedos. Escenarios que ni siquiera existen.
          </p>

          <p data-id="element-111">Y cuanto más intentas dormir, más despierta te sientes.</p>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12 text-xl md:text-2xl text-amber font-medium text-center" data-id="element-112">
          Es lo que llamo "vigilancia nocturna": un sistema nervioso que no ha
          recibido la señal de que puede bajar la guardia.
        </motion.p>
      </div>
    </section>;
}